import { HugeiconsIcon } from '@hugeicons/react'
import { Video01Icon, Share01Icon, Mail01Icon } from '@hugeicons-pro/core-solid-rounded'
import { MAC_CHECKOUT } from './MacPurchaseOptions.jsx'
import useMacPrice from './lib/useMacPrice.js'

const claimURL = `mailto:abelardeadrianangelo@gmail.com?${new URLSearchParams({
  subject: 'Keeby cashback claim',
  body: 'Purchase email:\nPolar order ID:\nPost link:\nPlatform:\nView count:\nClaim tier (50% or 100%):\n\nPlease attach a screenshot of the views.\n',
})}`

export default function CashbackPage() {
  const price = useMacPrice()
  return (
    <article className="mx-auto max-w-3xl px-6 pb-20 pt-28 sm:pt-36">
      <a href="/mac" className="text-sm text-neutral-500 hover:text-neutral-900">Keeby for Mac</a>
      <h1 className="mt-5 text-4xl font-extrabold tracking-tight sm:text-5xl">Post a Reel. Get 50% back.</h1>
      <p className="mt-5 max-w-md text-lg leading-relaxed text-neutral-600">Share your Keeby setup. Reach a view milestone and get half—or all—of your purchase back.</p>
      <p className="mt-3 text-sm text-neutral-500">For Keeby Mac website purchases through Polar. App Store and Windows purchases aren’t part of this program.</p>

      <ol className="mt-12 space-y-8">
        {[
          [Video01Icon, 'Film it', 'Record your keyboard with Keeby’s sounds and visualizer. Show your own setup and make the video yours.'],
          [Share01Icon, 'Post it', 'Share an original, public Instagram Reel, TikTok, or video on X. Include #keeby so we can find it.'],
          [Mail01Icon, 'Send your claim', 'Once one post reaches a milestone, email its link, a screenshot of the views, your purchase email, and your Polar order ID.'],
        ].map(([icon, title, description], index) => (
          <li key={title} className="flex gap-5">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-neutral-100" aria-hidden="true"><HugeiconsIcon icon={icon} size={22} /></span>
            <div><h2 className="text-lg font-semibold">{index + 1}. {title}</h2><p className="mt-1 max-w-sm text-sm leading-relaxed text-neutral-600">{description}</p></div>
          </li>
        ))}
      </ol>

      <section aria-label="Cashback milestones" className="mt-12 grid gap-4 sm:grid-cols-2">
        {[[ '2,000 views', '50% back', 'Half of what you paid.' ], [ '20,000 views', '100% back', 'Your full purchase price back.' ]].map(([views, reward, detail]) => (
          <div key={reward} className="rounded-3xl bg-neutral-100 p-7">
            <p className="text-sm text-neutral-500">{views} on Reels or TikTok</p>
            <h2 className="mt-3 text-3xl font-semibold tracking-tight">{reward}</h2>
            <p className="mt-3 text-sm text-neutral-600">{detail}</p>
          </div>
        ))}
      </section>
      <div className="mt-4 rounded-3xl border border-neutral-200 p-7">
        <h2 className="font-semibold">Posting on X works too.</h2>
        <p className="mt-2 text-sm leading-relaxed text-neutral-600">X counts impressions as views: 20,000 for 50% back, or 200,000 for 100% back.</p>
      </div>

      <div className="mt-8 flex flex-wrap items-center gap-4">
        <a href={claimURL} className="rounded-full bg-neutral-800 px-6 py-3 text-sm font-semibold text-white hover:bg-neutral-700">Email your claim</a>
        <a href={MAC_CHECKOUT} className="text-sm font-medium text-neutral-700 underline underline-offset-4">Get Keeby for Mac · {price}</a>
      </div>
      <p className="mt-4 text-sm leading-relaxed text-neutral-500">Claims go to abelardeadrianangelo@gmail.com. We review them manually and refund approved claims through Polar to the original payment method. You keep your Keeby license.</p>

      <section className="mt-12 border-t border-neutral-200 pt-7">
        <h2 className="text-lg font-semibold">A few simple rules</h2>
        <ul className="mt-4 list-disc space-y-3 pl-5 text-sm leading-relaxed text-neutral-600">
          <li>Views must be organic. No bought views, bots, or paid promotion.</li>
          <li>Post as often as you like. A single post must reach the milestone on its own; views aren’t combined across posts or platforms.</li>
          <li>One cashback payout per purchase. Choose your tier before claiming: a paid 50% claim cannot later be topped up to 100%.</li>
          <li>Cashback is based on what you actually paid after discounts, capped by the amount still refundable. Free orders have no cashback value. Polar handles the corresponding tax refund.</li>
          <li>Claims are checked by a person and that decision is final. The program may change, but claims already submitted will be honoured under the rules in place when submitted.</li>
          <li>You keep the rights to your video. Keeby may reshare it with credit unless you tell us not to.</li>
        </ul>
      </section>
    </article>
  )
}
